import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Skeleton from '../skeleton/Skeleton';

/**
 * Education Section Component
 * Renders education information with loading and error states
 */
const EducationSection = memo(({ educations, isLoading, error }) => {
    if (isLoading) {
        return <Skeleton type="resume" />;
    }

    if (error) {
        return (
            <div className="alert alert-warning" role="alert">
                <p className="mb-0">Unable to load education data. Please try again later.</p>
            </div>
        );
    }

    if (!educations?.length) {
        return (
            <div className="text-muted text-center py-4">
                <p className="mb-0">No education information available.</p>
            </div>
        );
    }

    return (
        <>
            {educations.map(({ id, name_of_degree, title, course_duration, college }) => (
                <article className="educations" key={id}>
                    <h3 className="text-5 mb-2">
                        {name_of_degree && title ? `${name_of_degree} in ${title}` : name_of_degree || title}
                    </h3>
                    {course_duration && (
                        <h6 className="mb-2 text-primary" aria-label="Course Duration">
                            {course_duration}
                        </h6>
                    )}
                    {college && (
                        <p className="text-muted mb-0 text-3">{college}</p>
                    )}
                    <hr className="my-4" />
                </article>
            ))}
        </>
    );
});

EducationSection.displayName = 'EducationSection';

EducationSection.propTypes = {
    educations: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            name_of_degree: PropTypes.string,
            title: PropTypes.string,
            course_duration: PropTypes.string,
            college: PropTypes.string
        })
    ),
    isLoading: PropTypes.bool.isRequired,
    error: PropTypes.string
};

EducationSection.defaultProps = {
    educations: [],
    error: null
};

export default EducationSection;